<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>phaser-scenes</title>
    <script type="module" src="./main.ts"></script>
  </head>
  <body>
    <nav>
      <a href="/2025-2026-pai-phaser-joseangel-kyliam-alejandro/">Go back to index</a>
    </nav>
    <div id="sprite-app"></div>
  </body>
</html>